module.exports = __webpack_public_path__ + "media/images/icons/grid-5e5a4523cf4ddae30a3bc970ac13cd1c.svg";